/********************* Welcome Discount Code *********************/

// check that we should apply the discount code
const hasWelcomeCode = !!welcomeDiscount.code;

// the previous promo code. meta ads still carry /discount/WELCOME20 links, so shopify puts it on the
// cart before any of our code runs
const STALE_DISCOUNT_CODE = "WELCOME20";

// check if we have a discount code currently applied
function welcomeDiscountApplied() {
    return !!cart.discount_codes?.some(code => {
        return code.code.toUpperCase() === welcomeDiscount.code.toUpperCase() && code.applicable === true;
    });
}

// any code shopify confirms applies to this cart, whatever it is called. the money off lines key off
// this rather than the welcome code, so the drawer never renders blank while a discount is live
function cartDiscountApplied() {
    return !!cart.discount_codes?.some(code => code.applicable === true);
}

// shopify refuses a valid code on an empty cart because there are no line items to allocate against,
// so a verdict only means anything once something is in the cart
function welcomeCodeRefused() {
    if (!hasWelcomeCode || cart.item_count === 0) {
        return false;
    }
    return !!cart.discount_codes?.some(code => {
        return code.code.toUpperCase() === welcomeDiscount.code.toUpperCase() && code.applicable === false;
    });
}

// apply the welcome code to a cart carrying no code, and switch the previous promo code over to it.
// any other code is the visitor's own and stays put
function shouldApplyWelcomeCode() {
    if (!hasWelcomeCode || cart.item_count === 0) {
        return false;
    }

    const cartCodes = cart.discount_codes?.map(code => code.code.toUpperCase()) || [];

    return cartCodes.length === 0 || cartCodes.includes(STALE_DISCOUNT_CODE);
}

// push the code onto the cart, return cart with new data
async function applyWelcomeDiscount() {
    try {
        // clear whatever is on the cart first - a code carried in on a /discount/CODE link is already
        // allocated, and shopify keeps that allocation unless we drop it before writing ours
        if (cart.discount_codes?.length > 0) {
            await updateCart({discount: ""});
        }

        cart = await updateCart({discount: welcomeDiscount.code})
        return cart;
    } catch (error) {
        console.error(`Could not apply discount ${welcomeDiscount.code}.`);
    }
}

/********************* Welcome Discount Popup *********************/

// sessionStorage key so the popup only toggles once, not on every pdp they browse
const WELCOME_POPUP_KEY = "welcomeDiscountShown";

// confirms the auto-applied discount once per session.
// popup comes from snippets/welcome-congrats.liquid, so every pdp shares one implementation
function initWelcomePopup() {
    const popup = document.querySelector('#welcomeCongrats');

    // nothing to do on pages that do not render the snippet, when the setting is blank, or once we
    // have already announced it this session
    if (!popup || !welcomeDiscount.code || sessionStorage.getItem(WELCOME_POPUP_KEY)) {
        return;
    }

    sessionStorage.setItem(WELCOME_POPUP_KEY, "1");

    // holds the auto close timer so a manual close can cancel it
    let congratsTimer = null;

    // close popup function
    function closeCongrats() {
        // drop the auto close timer, otherwise it fires again after a manual close
        clearTimeout(congratsTimer);

        popup.classList.remove('active');

        // wait for the transition to finish before actually closing
        setTimeout(() => {
            popup.close();
            document.querySelector('body').classList.remove('noScroll');
        }, 650);
    }

    // x icon click close
    popup.querySelector('#welcomeCongratsClose').addEventListener('click', closeCongrats);

    // outside click close
    popup.addEventListener('click', function (e) {
        if (e.target === this) {
            closeCongrats();
        }
    });

    // accessibility close
    popup.addEventListener('close', closeCongrats);

    // fill the copy before showing so it never paints empty
    popup.querySelector('#welcomeCongratsText').innerHTML = `Congrats! Your <strong>${welcomeDiscount.percent}% off Labor Day Sale discount</strong> has been auto-applied.`;

    popup.showModal();
    popup.classList.add('active');

    // this is a confirmation, not a decision, so dismiss it for them after six seconds
    congratsTimer = setTimeout(closeCongrats, 6000);
}

initWelcomePopup();
